export const MODAL_NAME = 'listings.deals-info'
